export const ASSETS = {
  FORWARD_BANNER_LOGO:
    'https://images.ctfassets.net/5965pury2lcm/7BCcmLZU3OeCG6FzjPjMoS/ef988802ba83a18e4fe8284518b2531a/Forward6-banner-logo.svg',
  Banner_FWD:
    'https://images.ctfassets.net/5965pury2lcm/6R4FjWfAyrz1i2K8oqqNub/a323c3fcea4155b5062c54f7dc039ddf/bg_fVI_banner.png',
  Video_Play_Icon:
    'https://images.ctfassets.net/5965pury2lcm/7821Kb5FLG93N7ootR8zKk/851de891ec776d2fd973c8dfd9ad430a/play-video-icon.svg',
  Red_Pillar_BG:
    'https://images.ctfassets.net/5965pury2lcm/Y8z1ezVSyI1y8tUgNEd7V/0d91fcce041290286e13e1ed5e85996e/pink-pillar.png',
  Yellow_Pillar_BG:
    'https://images.ctfassets.net/5965pury2lcm/1nwIivFryZR8XKxImu1TJP/9c0f95638ca4dc951b6e4512ba7e56bb/orange-pillar.png',
  Blue_Pillar_BG:
    'https://images.ctfassets.net/5965pury2lcm/k6mGHZmKVLHx3h3nE2mzu/a39b4a8f2d888ffb364c7228534b28e5/blue-pillar.png',
  Red_Pillar_SHAPE:
    'https://images.ctfassets.net/5965pury2lcm/Orml6cRBT8vGSxXfRjJyL/201c7b7f2dc759219ecb8e129829bb5e/white-shape2.png',
  Yellow_Pillar_SHAPE:
    'https://images.ctfassets.net/5965pury2lcm/3MyANkT2ahPv7l6ium1e2z/5081f7e1d6ebcb2326ed4080ce0ea148/white-shape.png',
  Blue_Pillar_SHAPE:
    'https://images.ctfassets.net/5965pury2lcm/4i7AeEZOtZDZbHeK2BepF7/c47695510763f981be694d29db513e44/white-shape1.png',
  PILLAR_PATTERN:
    'https://images.ctfassets.net/5965pury2lcm/1ASB85gejJTrrvs4HLwovV/aa1ab899bd60ee07c98bd72ab6cd8335/pattern.png',
  BLOG_POST_ROBOT:
    'https://images.ctfassets.net/5965pury2lcm/4XoMG9HzpeA1RK5OuXT40P/c609b68a4f50720181fcc37995eae6ab/Left.png',
  MAIL_ICON:
    'https://images.ctfassets.net/5965pury2lcm/1hXSNS41cgsUwwJjwtL0zQ/e9f537c843a39ffa90bf50229bc60619/Icon-light-contact-email.svg',
  UP_ARROW_ICON:
    'https://images.ctfassets.net/5965pury2lcm/5AWMlpmpSqveY4Ekn7oPyX/075fc0b80935bf76fe6bc707c3dd9d6d/Arrow_Up.svg',
  UP_ARROW_LIGHT_ICON:
    'https://images.ctfassets.net/5965pury2lcm/19t2yr8Go4Hb4kN8jVJgkg/1fbc99e8b4c5fe01180bc7c6801c321f/Arrow_Up-White.svg',
  HERO_SOLUTIONS_BACKGROUND:
    'https://images.ctfassets.net/5965pury2lcm/1swgruP0ClYB0WhRUh9wfP/8e4a6d113015cee67e0a2f90cc1967b2/SolutionsHeroBG.png',
  HERO_COMPANY_LISTING_BACKGROUND:
    'https://images.ctfassets.net/5965pury2lcm/4iUydleB0jjTj8pbuhs8I6/e0617e3ec9452106504949bc8339cd65/image_1.png',
  HERO_FORM_FLEX_BACKGROUND:
    'https://images.ctfassets.net/5965pury2lcm/3IB5Ku9xpTutzywBR8zJKO/0cfa1f191ced10bed75617f7cce8977f/Bg_Hero_Gray.png',
  CENTER_TEXT_WITH_DOTS:
    'https://images.ctfassets.net/5965pury2lcm/5IHctXhjd9qqmvcpC5KQ3K/d3d95fbb5ce11b95e9ef1d2f98f14625/Hero_BG_fullcomp.png',
  ROBOT_SPOTLIGHT:
    'https://images.ctfassets.net/5965pury2lcm/O01jnRaKE15bgX6IVkgt1/e985f99b12c0e2546cef6b62e3ff067a/robot_spotlight_1x.png',
  BLOCKQUOTE:
    'https://images.ctfassets.net/5965pury2lcm/6D8NmS3Zf7JZLkVIzD0UjL/97aa5dce32ab883531b4697ff3cf531e/heist-blog-blockquote-quotes.svg',
  PLUS_ICON:
    'https://images.ctfassets.net/5965pury2lcm/1H6PRosfekEQh4MEhwvk0K/cab8d5080915e46049049a96cbf43169/plus-icon.png',
  DOWNLOAD_ICON:
    'https://images.ctfassets.net/5965pury2lcm/HObHSPkCpjalZDiwe9KvW/1fd5e2db19617036d977d3eb52e050ee/Download-Icon.png',
  MAIN_CTA_LARGE:
    'https://images.ctfassets.net/5965pury2lcm/7IFUtInC8kyPBw8YZGvbId/c0eb86d7d29130b8e08e8d9b8b83f8f5/MainCTA-LG-MD.png',
  MAIN_CTA_SMALL:
    'https://images.ctfassets.net/5965pury2lcm/4Jh9GmFfspu4LTyHp5fGEv/803f9c7cf5baeeb3299f21fcc12e7e3d/MainCTA-SM-XS.png',
  TRANSPARENT_MACS:
    'https://images.ctfassets.net/5965pury2lcm/3GJn1WAJqb6JBLO5eiVA1E/8e19493087b9653a6474308069ae368d/transparent-macs.svg',
  BLOG_POPUP_ROBOT:
    'https://images.ctfassets.net/5965pury2lcm/1kQc2KAWdjN3yzdAbGYRaU/129a840ec2799f10935b0af152bcce14/blog-popup-robot.png',
  TRANSPARENT_ROBOT:
    'https://images.ctfassets.net/5965pury2lcm/3fTUgGix12QmaA6D2qhYyu/e4fda7d18f72d2f6051ab9f9c39e19de/developers-uipath-robot-transparent.png',
  MACARONI_WHITE:
    'https://images.ctfassets.net/5965pury2lcm/5iIyErbWLtmjny2WrxInm6/6de257cd4488be92acba0c7304cb0ea1/Macaroni-White.png',
  PATH: 'https://images.ctfassets.net/5965pury2lcm/3rUXDMGbtk3yn8Y594DVD4/e48477aa550f6ceb81602e9f6bd4decd/Path.png',
  HERO_BACKGROUND:
    'https://images.ctfassets.net/5965pury2lcm/6yN08XkwEtkRdnasdX2DFS/5fcadd6978e925f596677c1e672d1706/HERO_Background__1_.png',
  BLOG_HEADER_DECORATION:
    'https://images.ctfassets.net/5965pury2lcm/3OgxA3z3S6rIykQkMMHxRI/0824d70c485ac3771022745f69963aae/heist-v2-blog-header-decoration.svg',
  BLOG_ROBOT:
    'https://images.ctfassets.net/5965pury2lcm/w4dR8WWNxkfLokcZbBvVZ/595b96524f4aa991fe380d7cff62b0de/UiPath-Blog-Robot-Icon.png',
  CONTACT_EMAIL:
    'https://images.ctfassets.net/5965pury2lcm/7tLFktvb9gU5OBoXYGZVCI/505f06436d1e6b9df3bdfd0874311d20/contact-email_alt.png',
  RIGHT:
    'https://images.ctfassets.net/5965pury2lcm/2TA7SYTkjydtpUobhssY8A/b3bfad8a30ff11e513d9c60d803ee261/Right.png',
  HEADER_HERO:
    'https://images.ctfassets.net/5965pury2lcm/3V4TlijoFjIItTIeB09sp8/3c2bf21d9520c4dca1e12b24b61dbb1b/header-hero.webp',
  PRODUCT_MACARONI:
    'https://images.ctfassets.net/5965pury2lcm/7eoe48KGKSX7VAaQCRRcgV/ac321357dee0cd83ae6bbe6411a6b27d/Product-Download-Page-Macaroni.png',
  TIMEZONE_THANK_YOU:
    'https://images.ctfassets.net/5965pury2lcm/2bhf6WFigf5S0bbnPUZHQ2/0bcf8eb01c4e27636199c0efecc7f7fa/Timezone-Thankyou-BG.jpg',
  ARROW_SMALL_RIGHT:
    'https://images.ctfassets.net/5965pury2lcm/6fBlZ8oEF9bKZlt4rGEfEJ/9cb472e57a34bf56edf510836cc93816/ArrowSmall2X_Right.svg',
  QUOTE:
    'https://images.ctfassets.net/5965pury2lcm/3DSiH3KemoK973VzfW2HbX/7169c608578292d26579a137ce224b60/Quote.svg',
  TWITTER:
    'https://images.ctfassets.net/5965pury2lcm/4dAYUTsXPrkP1BNdPSFmSp/c65e9a1d6fedea138b5c79ae4cb9a26f/Twitter24x24.svg',
  LINKEDIN:
    'https://images.ctfassets.net/5965pury2lcm/229hKtHNHuk5CtK8CJLnh/2ae651f3bb0995f2ced37f008ac619b5/Linkedin16x16.svg',
  TWITTER_HOVER:
    'https://images.ctfassets.net/5965pury2lcm/1GjxGoTBTRRFpxevacnau6/4eeda6e6ee80bd43f4fb309d6cf4ef61/Twitter_Icon_Hover.svg',
  LINKEDIN_HOVER:
    'https://images.ctfassets.net/5965pury2lcm/48rlfbSTKg2uv9RQesJX1w/49c4630153c0416ef365f06be3736263/LinkedIn_Icon_Hover.svg',
  HERO_NEWSROOM:
    'https://images.ctfassets.net/5965pury2lcm/2INaGHDDw9uI0HAkIzpHLU/b8fab74cb56f36e75608f760b0d7f2e2/Hero_Newsroom_2x.png',
  CUSTOMER_STORY_BACKGROUND:
    'https://images.ctfassets.net/5965pury2lcm/6A4g7G09xDAVYJL34096Jc/b14536cbbece48aff74212fc913816d2/UiPath-Customer-Story-Background.jpg',
  CUSTOMER_STORY_BACKGROUND_MD:
    'https://images.ctfassets.net/5965pury2lcm/6p4rTJ8SDaRVRoJ8YDyB43/a522f70c6283cfc413c99cd69dbce5e1/UiPath-Customer-Story-Background-MD.jpg',
  CUSTOMER_STORY_BACKGROUND_SM:
    'https://images.ctfassets.net/5965pury2lcm/54uNMgVb6tOOF122MxUEXT/2dd7c2e536a157b1400a4a99ef2c21b4/UiPath-Customer-Story-Background-SM.jpg',
  X_ICON_WHITE:
    'https://images.ctfassets.net/5965pury2lcm/1JXOngMrnkhHQvWgegGKIy/22d441351e0b349d6c55dae407ec09e4/X-Icon-White.png',
  ERRORS:
    'https://images.ctfassets.net/5965pury2lcm/3BIcaw9GtzKFLmNtPhGLCo/15d3a016de92a9a44581692940c64c92/Error.png',
  WHITE_FILTER_BUTTON:
    'https://images.ctfassets.net/5965pury2lcm/4mehQy1K2mWOjEitNgUrUF/3a7ac068be8daffdbe9b2941eef34f76/FilterButton-White.png',
  BLACK_FILTER_BUTTON:
    'https://images.ctfassets.net/5965pury2lcm/4zQRnU1TwLcahG5dxnHB66/d5640aad4313beebc9642a2d467941bb/FilterButton-Black.png',
  WHITE_CLOCK:
    'https://images.ctfassets.net/5965pury2lcm/3cKpn0HNi5gLFFlLsECOOz/c41fb5a4847f301edd1b64837b4d09c2/Clock2clockWhite.png',
  FEATURED_SLIDER_ROBOT:
    'https://images.ctfassets.net/5965pury2lcm/1aRPOYeVXfpWo2HNoOYPZX/bcd74ac16862678eb57b338b008643e2/featured_slider_robot.svg',
  KEYSTATS_FEATURED_EVENT:
    'https://images.ctfassets.net/5965pury2lcm/6nSWKuQHkuVT6VFiYP3zKk/5711383596d8ee605e5832059edcd799/keystat-featured-event.png',
  HOME_ICON_LOGO:
    'https://images.ctfassets.net/5965pury2lcm/5TKEqrAzK6IpEo1ITITY31/f178ca99e590f0c33af22280ce271748/home.png',
}
